import { Box, Card, Flex, Text, Button } from "@radix-ui/themes";
import { AlertCircle } from "lucide-react";

const NotFound = () => {
  return (
    <Box p="4">
      <Card>
        <Box p="6">
          <Flex direction="column" align="center" gap="4">
            <Box>
              <AlertCircle size={48} style={{ color: "var(--red-9)" }} />
            </Box>

            <Text size="6" weight="bold" align="center">
              Item Not Found
            </Text>

            <Text size="3" color="gray" align="center">
              The resource you're looking for doesn't exist or has been deleted.
            </Text>

            <Button
              variant="soft"
              color="gray"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </Flex>
        </Box>
      </Card>
    </Box>
  );
};

export default NotFound;
